import React, { Fragment, Component } from 'react';
import CarouselPagination from 'elements/Pagination/CarouselPagination/CarouselPagination';
import { bool, string, func, object, arrayOf, number } from 'prop-types';
import classnames from 'classnames/bind';
import jump from 'jump.js';

import styles from './VerticalSectionMarker.css';

const cx = classnames.bind(styles);

class VerticalSectionMarker extends Component {
  static propTypes = {
    landing: bool,
    title: string,
    sections: arrayOf(object).isRequired,
    onClick: func,
    offset: number,
  }

  static defaultProps = {
    offset: 0
  }

  state = {
    setionTitle: this.props.sections[0].name,
    currentSectionIndex: 1
  }

  sectionsOffsets = null;
  lastSection = null;


  componentDidMount = () => {
    const { sections } = this.props;

    this.sectionsOffsets = sections.map( section => {
      const detailedSection = section;
      const el = document.getElementById(section.id);

      detailedSection.start = el.offsetTop;
      detailedSection.end = el.offsetTop + el.offsetHeight;

      return detailedSection;
    });

    this.lastSection = this.sectionsOffsets[0];

    window.addEventListener('scroll', this.handleWindowScroll);
  }

  componentWillUnmount = () => window.removeEventListener('scroll', this.handleWindowScroll);

  updateCurrentSection = windowOffset => {
    const { sectionsOffsets } = this;

    sectionsOffsets.forEach((section, i) => {
      const sectionIndex = i + 1;

      if ( windowOffset > section.start && windowOffset < section.end ) {
        this.setState({
          setionTitle: section.name,
          currentSectionIndex: sectionIndex
        });

        this.lastSection = section;
        return;
      }
    });
  }

  handleWindowScroll = () => {
    const { offset } = this.props;
    const { lastSection } = this;
    const pageYOffset = window.pageYOffset + 1 + offset;
    const betweenCurrentSection = pageYOffset >= lastSection.start && pageYOffset < lastSection.end;

    if (!betweenCurrentSection) {
      return this.updateCurrentSection(pageYOffset);
    }
  }

  handleClick = e => {
    const { onClick, offset, landing } = this.props;
    
    landing
      ? this.scrollToLandingElement(e, offset)
      : this.scrollToElement(e, offset)
    ;
    
    onClick && onClick(e);
  }

  scrollToElement = (e, offset) => {
    const { id } = e.currentTarget.dataset;
    const node = document.getElementById(id);

    jump(node, { offset: - offset });
  }

  scrollToLandingElement = (e, offset) => {
    const nextSection = e.currentPage;
    const sectionReceived = this.sectionsOffsets[nextSection - 1];
    const node = document.getElementById(sectionReceived.id);

    this.setState({
      currentSectionIndex: nextSection,
      setionTitle: sectionReceived.name
    });

    jump(node, { offset: - offset });
  }

  renderStandard = () => {
    const { title, sections } = this.props;

    return (
      <Fragment>
        <div className={styles.sectionHead}>
          <p className={classnames('large', styles.title)}>{title}</p>
        </div>
        <ul className={styles.sectionList}>
          {
            sections.map((section, i) => (
              <li key={`section-item-${i}`}>
                <a
                  className={styles.sectionItem}
                  onClick={this.handleClick}
                  data-id={section.id}
                >
                  <p className={styles.sectionName}>
                    {section.name}
                  </p>
                </a>
              </li>
            ))
          }
        </ul>
      </Fragment>
    );
  }

  renderLanding = () => {
    const { sections } = this.props;
    const { setionTitle, currentSectionIndex } = this.state;

    return (
      <Fragment>
        <div className={styles.sectionHead}>
          <div className={styles.logo} />
        </div>

        <div className={styles.carousel}>
          <CarouselPagination
            vertical
            responsive
            totalItems={sections.length}
            label={setionTitle}
            currentPage={currentSectionIndex}
            onPageChange={this.handleClick}
          />
        </div>
      </Fragment>
    );
  }

  render () {
    const { landing } = this.props;

    return (
      <div className={cx('container', { 'landing': landing })}>
        { !landing && this.renderStandard() }
        { landing && this.renderLanding() }
      </div>
    );
  }
}

export default VerticalSectionMarker;



// WEBPACK FOOTER //
// ./src/uis/components/VerticalSectionMarker/VerticalSectionMarker.js